export enum ID3 {
	NAME = 'pplus.id3',
	BROADCAST_END = 'broadcast_end',
	GAME_END = 'game_end',
	LINEAR_AD_TRACKING = 'com.paramount.vtg'
}